// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAE0rxhCHKh4d4G5fy3HleBjJhFD9p-oN4",
    authDomain: "platzinger-b8062.firebaseapp.com",
    databaseURL: "https://platzinger-b8062.firebaseio.com",
    projectId: "platzinger-b8062",
    storageBucket: "platzinger-b8062.appspot.com",
    messagingSenderId: "638695157174",
    appId: "1:638695157174:web:a4957bad619fe794b56517"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
